module.exports = ":host .category-form-list__button-container {\n  margin-top: 5em; }\n\n:host .buttons {\n  -ms-flex-direction: row;\n  align-content: flex-end;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/categories/categories.scss
// module id = 2vNM
// module chunks = 12